import { Icon } from '@imprivata-cloud/design-system';
import type { BannerProps } from '../../../Banner/banner';
import { Banner } from '../../../Banner/banner';
import { HexContainer } from '../hex-container/hex-container';
import './authentication-header.less';

interface AuthenticationHeaderProps {
  hexImage?: React.ReactNode;
  logoUrl?: React.ReactNode;
  banner?: BannerProps;
}

export const AuthenticationHeader = ({
  hexImage = <Icon name="username" />,
  logoUrl,
  banner,
}: AuthenticationHeaderProps) => {
  return (
    <div className="authn-layout-header">
      {banner && (
        <Banner
          key={`${banner.status}-${banner.message ?? ''}`}
          status={
            banner.status === 'error' || banner.status === 'warning'
              ? 'warning'
              : banner.status
          }
          message={banner.message}
          subMessage={banner.subMessage}
          customIcon={banner.customIcon}
          className="authentication-banner"
          clearBanner={banner.clearBanner}
        />
      )}
      <span className="authn-layout-header-logo">{logoUrl}</span>
      <HexContainer className="authn-layout-header-hex" icon={hexImage} />
    </div>
  );
};
